import { Outlet } from 'react-router-dom';
import TopBar from './TopBar';
import './AppLayout.css';

function AppLayout() {
  return (
    <div className="app-layout">
      <TopBar />
      <main className="app-layout__main">
        <Outlet />
      </main>
    </div>
  );
}

export default AppLayout;
